import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ExposuresWrapperStyle: StyleExtend<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: '1.5rem',
  color: (theme) => theme.palette.customColors.gunMetal,
};

export const ExposuresWrapperDescriptionStyle: StyleExtend<Theme> = {
  marginTop: '.5rem',
};
